<script setup lang="ts">
import { inject } from 'vue'
import { useLocalization } from '@hantera/portal-app'
import type { useRoleStore } from '@/stores/iam/role-store'
import PermissionPicker from '../Shared/PermissionPicker.vue'

const store = inject<ReturnType<typeof useRoleStore>>('roleStore')!
const t = useLocalization('iam.roles')
</script>

<template>
  <div v-if="store.role" class="permissions-tab">
    <div class="picker-margin">
      <div v-if="store.isSystemRole" class="box-warning p2">
        {{ t('systemRolePermissionsInfo') }}
      </div>

      <PermissionPicker v-model="store.displayPermissions" :readonly="store.isSystemRole" />
    </div>
  </div>

  <div v-else-if="store.isLoading" class="loading-state">
    <p>{{ t('loading') }}</p>
  </div>

  <div v-if="store.hasUnsavedPermissions && store.canEdit" class="action-bar">
    <button @click="store.savePermissions" class="btn-primary">{{ t('saveChanges') }}</button>
    <button @click="store.discardPermissions" class="btn-silent">{{ t('discard') }}</button>
  </div>
</template>

<style scoped>
.permissions-tab {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.loading-state {
  padding: 40px;
  text-align: center;
  color: var(--color-text-secondary);
}

.picker-margin {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  height: 100%;
}

.action-bar {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  border-top: 1px solid hsl(var(--color-80));
  background: hsl(var(--color-90));
  position: sticky;
  bottom: 0;
  box-shadow: 0 0px 20px var(--color-shadow);
}
</style>
